import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useLang } from "@/lib/i18n";

export const PasswordInput = ({ className = "", testid, ...props }) => {
  const { t } = useLang();
  const [show, setShow] = useState(false);
  return (
    <div className="relative" dir="ltr">
      <Input {...props} type={show ? "text" : "password"} dir="ltr" autoCapitalize="none" autoCorrect="off" spellCheck={false}
        className={`xd-input pe-12 ${className}`} data-testid={testid} />
      <button type="button" onClick={() => setShow(!show)} aria-label={t(show ? "auth.hide_password" : "auth.show_password")} aria-pressed={show}
        title={t(show ? "auth.hide_password" : "auth.show_password")}
        className="absolute inset-y-0 end-0 w-12 grid place-items-center text-zinc-400 hover:text-white focus-visible:text-white" data-testid={`${testid}-toggle`}>
        {show ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
};
